import { ProductBM } from 'src/types/BusinessModel/Stowage/Product/ProductBM';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { createValueRange } from './ValueRangeFactory';
import { createUscgGroup } from './UscgGroupFactory';
import { createImdgCodeClass } from './ImdgCodeClassFactory';

export const createProduct = (productBM: ProductBM): Product => {
    if (
        !productBM.physicalData.litreWeight ||
        !productBM.physicalData.litreWeightCorrectionFactor ||
        !productBM.physicalData.litreWeightReferenceTemperature?.value ||
        !productBM.regulations.uscgGroup ||
        !productBM.temperatureRequirements.maxAdjacentTemperature ||
        !productBM.temperatureRequirements.voyageTemperatureRange.maxValue
    ) {
        return null;
    }
    return {
        id: productBM.id,
        categoryId: productBM.categoryId,
        tradeName: productBM.tradeName,
        chartererName: productBM.charterer?.name ?? null,
        maxAdjacentTemperature: productBM.temperatureRequirements.maxAdjacentTemperature?.value,
        litreWeight: productBM.physicalData.litreWeight?.value ?? 1,
        litreWeightCorrectionFactor: productBM.physicalData.litreWeightCorrectionFactor,
        litreWeightReferenceTemperature: productBM.physicalData.litreWeightReferenceTemperature?.value ?? 0,
        loadingTemperatureRange: createValueRange(productBM.temperatureRequirements.loadingTemperatureRange),
        voyageTemperatureRange: createValueRange(productBM.temperatureRequirements.voyageTemperatureRange),
        unloadingTemperatureRange: createValueRange(productBM.temperatureRequirements.unloadingTemperatureRange),
        flashPointRange: createValueRange(productBM.physicalData.flashPointRange),
        boilingPointRange: createValueRange(productBM.physicalData.boilingPointRange),
        meltingPointRange: createValueRange(productBM.physicalData.meltingPointRange),
        uscgGroup: productBM.regulations.uscgGroup ? createUscgGroup(productBM.regulations.uscgGroup) : null,
        imdgCodeClass: productBM.regulations.imdgCodeClass ? createImdgCodeClass(productBM.regulations.imdgCodeClass) : null,
        category: null,
        euAllowance: productBM.regulations.euAllowance,
        fosfaAllowance: productBM.regulations.fosfaAllowance,
        niop1Allowance: productBM.regulations.niop1Allowance,
        niop2Allowance: productBM.regulations.niop2Allowance,
        unCode: productBM.externalIds?.find((id) => id.source === 'UN')?.value
            ? parseInt(productBM.externalIds?.find((id) => id.source === 'UN')?.value)
            : null,
    };
};

export const createProductList = (list: ProductBM[]) => list.map((product) => createProduct(product)).filter((p) => p !== null);
